import styles from './button.module.scss';
import { CSSProperties } from 'react';
import { LoaderCircleIcon } from 'lucide-react';

interface Props {
    onClick?: () => void;
    text: string;
    disabled?: boolean;
    loading?: boolean;
    style?: CSSProperties;
}

const Button = (props: Props) => {
    return (
        <button
            type={'button'}
            className={styles.button}
            onClick={props.onClick}
            disabled={props.disabled || props.loading}
            aria-busy={props.loading}
            style={props.style}
        >
            {props.loading && (
                <LoaderCircleIcon
                    className={styles.spinner}
                    size={20}
                    aria-hidden="true"
                />
            )}
            <span>{props.text}</span>
        </button>
    );
};

export default Button;
